import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const pad = (n) => String(n).padStart(2, "0");

const parseLocal = (iso) => {
  const [d, t = "00:00"] = iso.split("T");
  const [y, m, day] = d.split("-").map(Number);
  const [h, min] = t.split(":").map(Number);
  return new Date(y, m - 1, day, h, min || 0);
};

export function DropCountdown() {
  const [drop, setDrop] = useState(null);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    api.drop().then(setDrop).catch(() => {});
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  if (!drop) return null;
  const target = parseLocal(drop.date).getTime();
  if (Number.isNaN(target)) return null;
  const diff = target - now;
  const live = diff <= 0;
  const d = Math.max(0, Math.floor(diff / 86400000));
  const h = Math.max(0, Math.floor(diff / 3600000) % 24);
  const m = Math.max(0, Math.floor(diff / 60000) % 60);
  const s = Math.max(0, Math.floor(diff / 1000) % 60);

  return (
    <div data-testid="drop-countdown" className="mt-6 relative w-full max-w-md -ml-2">
      <img
        src="/assets/torn-strip.png"
        alt=""
        aria-hidden
        draggable={false}
        className="w-full h-auto select-none pointer-events-none [filter:drop-shadow(0_6px_14px_rgba(17,17,17,0.14))]"
      />
      <div className="absolute inset-0 flex flex-col items-center justify-center pb-[8%]">
        <span className="font-college text-sm sm:text-base text-red" data-testid="drop-name">
          {live ? `THE ${drop.name} DROP IS LIVE` : `NEXT DROP — ${drop.name}`}
        </span>
        {!live && (
          <span className="font-college text-2xl sm:text-3xl text-navy tracking-wider tabular-nums" data-testid="drop-timer">
            {d}D {pad(h)}H {pad(m)}M {pad(s)}S
          </span>
        )}
      </div>
    </div>
  );
}
